type TError = {
  code: string;
};

export const isLimitExceed = (errors: TError[]): boolean =>
  Boolean(
    errors?.find(({ code }: TError) => code === 'dailyLimitExceed' || code === 'specialistNewRequestsLimitExceed'),
  );
